export type TabConfig = Partial<{
  size: TabSize;
  disabled: boolean;
  headerPadding: TabPadding;
  showHeader: boolean;
}>;

export enum TabSize {
  Large = 'large',
  Small = 'small',
}
export enum TabPadding {
  Large = 'large',
  Small = 'small',
}
